import { createSlice } from "@reduxjs/toolkit";
import {
  getListingsService,
  getListingsByIdService,
  createListingsService,
} from "../services/listings_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  listinigList: [],
  metaListings: null,
  listingsInfo: null,

  isLoadingAction:false
};

const slice = createSlice({
  name: "listings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ALL Listinigs
      .addCase(getListingsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listinigList = action.payload?.data?.data;
        state.metaListings = action.payload?.data?.meta?.meta;
      })
      .addCase(getListingsService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getListingsService.pending, (state) => {
        state.isLoading = true;
      })

      // GET Listinig BY ID
      .addCase(getListingsByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.listingsInfo = action.payload?.data?.data;
      })
      .addCase(getListingsByIdService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getListingsByIdService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createListingsService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
   
      })
      .addCase(createListingsService.rejected, (state) => {
        state.isLoadingAction = false;
      })
      .addCase(createListingsService.pending, (state) => {
        state.isLoadingAction = true;
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
